var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg26Arrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-10 -40 140 140",
    fill: "none",
    stroke: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m0 14.960629l89.732285 0l0 -14.960629l29.921257 29.921259l-29.921257 29.921259l0 -14.9606285l-89.732285 0z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg26Arrow);
export default __webpack_public_path__ + "static/media/26-arrow.563a9a70d255b6bd480e0268a4fa1bca.svg";
export { ForwardRef as ReactComponent };